<div class="relative">
  <div class="sticky top-0 z-50">
    <div class="bg-primary">
      <app-top-banner [activeSubscription] = "activeSubscription"></app-top-banner>
    </div>
    <div>
      <app-navbar></app-navbar>
    </div>
  </div>
  <section class="container pt-8">
    <router-outlet></router-outlet>
  </section>
</div>
